import {Regulation} from 'types';
import {TFunction} from 'react-i18next';
import {renderHeaderXL, createZIPXL} from './ExcelExportCommon';
import Excel from 'exceljs';

interface IRegulationsPage {
	(entityListItems: any[], columnNames: string[], t: TFunction): Promise<void>;
}

export const handleClickRegulations: IRegulationsPage = async (
	entityListItems,
	columnNames,
	t,
) => {
	const filtRegulation = entityListItems as Regulation[];

	const workbook = new Excel.Workbook();
	const sheet = workbook.addWorksheet(
		'TRACE_' +
			t('Regulations', {
				ns: 'features/regulations',
				keyPrefix: 'RegulationsList',
			}),
	);
	const columns = columnNames.map(x => {
		return {name: x, filterButton: true};
	});
	const arrColWidth: number[] = [15, 40, 80, ...new Array(4).fill(25)];
	const strPageName = t('Regulations', {
		ns: 'features/regulations',
		keyPrefix: 'RegulationsList',
	});

	renderHeaderXL(workbook, sheet, arrColWidth, strPageName, t);

	let intRowCount = 4;
	let row = sheet.getRow(intRowCount);
	row.alignment = {wrapText: true, vertical: 'top'};
	row.font = {
		bold: true,
		name: 'Porsche Next TT',
		size: 10,
		color: {argb: 'FFFFFFFF'},
	};

	sheet.addTable({
		name: 'Regulations',
		ref: 'B' + String(intRowCount),
		style: {
			showRowStripes: true,
		},
		columns,
		rows: [],
	});

	const table = sheet.getTable('Regulations');

	intRowCount++;
	for (let ii = 0; ii < filtRegulation.length; ii++) {
		const iRegulation = filtRegulation[ii];
		row = sheet.getRow(intRowCount);
		row.alignment = {wrapText: true, vertical: 'top'};
		table.addRow([
			(iRegulation.attachments ?? []).map(x => x.attachmentId).join(';\n'),
			iRegulation.regulationNumber,
			iRegulation.name,
			iRegulation.markets.map(market => market.name).join(';\n'),
			iRegulation.mainKeywords.map(keyword => keyword.name).join(';\n'),
			iRegulation.keywords.map(keyword => keyword.name).join(';\n'),
			iRegulation.standardPlusPcmsClusters.map(PCMS => PCMS.name).join(';\n'),
		]);
		intRowCount++;
	}

	table.commit();
	const strZipName = t('Regulations', {
		ns: 'features/regulations',
		keyPrefix: 'RegulationsList',
	});
	await createZIPXL(workbook, strZipName, t);
};
